import { useAppSelector } from '@app/core/hooks/redux-hooks';
import GridTextField from '@app/shared/components/grid-controls/grid-text-field/GridTextField';
import { Alignment } from '@app/shared/enums/alignment.enum';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { numericBaseFieldFormattingProps } from '@app/shared/components/form-controls/form-field/form-field-patterns';
import { useLocale } from '@app/core/hooks/useLocale';
import { getRequiredValidator } from '@app/core/validations/hook-forms/validators';
import DealThesisEmptyHistoricDataColumns from '../../deal-thesis-utils/DealThesisEmptyHistoricDataColumns';
import useDealThesisData from '../../deal-thesis-utils/useDealThesisData';

const OperationalFreeCashFlowSection2: FC = (): JSX.Element => {
  const { caseId } = useParams();
  const { l } = useLocale();
  const {
    historicDataForecastYearsResults,
    pwermCaseDataForecasts,
    getMaxColspan,
    showHistoricDataColumns,
  } = useDealThesisData(caseId);
  const project = useAppSelector((state) => state.project.projectDraft);
  const historicData = project.pwermInput.historicForecasts;
  const numberOfInputHistoricForecastYears = historicData.length;

  return (
    <>
      <tbody>
        <tr>
          <th className="table-primary__cell--header">{l('_OperationalFreeCashFlowTitle')}</th>
          <td colSpan={getMaxColspan() - 1} className="table-primary__cell--header" />
        </tr>
        <tr className="table-primary__row--plain">
          <th className="table-primary__cell--vertical-separator">
            {l('_OperationalFreeCashFlow')}
          </th>
          <DealThesisEmptyHistoricDataColumns isHistoricEventsSection={false} />
          {showHistoricDataColumns &&
            historicDataForecastYearsResults.map((data, index) => (
              <td key={index}>
                <GridTextField
                  name={`historicForecasts.${
                    numberOfInputHistoricForecastYears - index - 1
                  }.operationalFreeCashFlow`}
                  alignment={Alignment.Right}
                  {...numericBaseFieldFormattingProps}
                  placeholder="0"
                />
              </td>
            ))}
          <td />
          {pwermCaseDataForecasts?.map((_, index) => (
            <td key={index + 'cash-flow'}>
              <GridTextField
                name={`forecasts.${index}.inputs.operationalFreeCashFlow`}
                alignment={Alignment.Right}
                {...numericBaseFieldFormattingProps}
                rules={{
                  ...getRequiredValidator(),
                }}
                placeholder="0"
              />
            </td>
          ))}
          <td />
        </tr>
      </tbody>
    </>
  );
};

export default OperationalFreeCashFlowSection2;
